import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Progress } from "reactstrap";

const AnimateLoading = () => {
  const location = useLocation();
  const [width, setWidth] = useState(0);
  const prevPathname = useRef(location.pathname);
  const animateTimeout = useRef(null);
  const stopAnimateTimeout = useRef(null);

  // Run animation when route changes
  useEffect(() => {
    if (location.pathname !== prevPathname.current) {
      prevPathname.current = location.pathname;
      animate();
    }

    return () => {
      clearTimeout(animateTimeout.current);
      clearTimeout(stopAnimateTimeout.current);
    };
  }, [location.pathname]);

  const animate = () => {
    animateTimeout.current = setTimeout(() => {
      setWidth((prev) => {
        if (prev >= 100) {
          stopAnimate();
          return prev;
        } else {
          animate();
          return prev + 10;
        }
      });
    }, 30);
  };

  const stopAnimate = () => {
    clearTimeout(animateTimeout.current);
    stopAnimateTimeout.current = setTimeout(() => {
      setWidth(0);
    }, 300);
  };

  return (
    <div
      className="header-progress-bar"
      style={{ height: "3px", width: "100%" }}
    >
      {width > 0 && <Progress value={width} style={{ height: "3px" }} />}
    </div>
  );
};

export default AnimateLoading;
